var _style, _g, _g2, _path, _path2, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoVertical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 110.9,
    height: 148.7,
    x: "0px",
    y: "0px",
    viewBox: "0 0 110.9 149.4",
    style: {
      enableBackground: "new 0 0 110.9 149.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:url(#SVGID_2_);}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_3_);}\r\n\t.st4{fill:none;stroke:url(#SVGID_4_);stroke-width:1.5;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,125.6c-1.5,0-2.8-0.3-4-1c-1.2-0.7-2.1-1.6-2.8-2.8c-0.7-1.2-1-2.5-1-4v-12.9c0-0.4,0.1-0.8,0.4-1 c0.3-0.3,0.6-0.4,1-0.4c0.4,0,0.8,0.1,1,0.4c0.3,0.3,0.4,0.6,0.4,1v7.6c0.7-0.8,1.5-1.4,2.4-1.9c0.9-0.5,2-0.7,3.1-0.7 c1.4,0,2.6,0.3,3.7,1c1.1,0.7,2,1.6,2.6,2.8c0.6,1.2,0.9,2.5,0.9,4s-0.3,2.8-1,4c-0.7,1.2-1.6,2.1-2.8,2.8 C10.6,125.3,9.3,125.6,7.8,125.6z M7.8,123.1c1,0,1.8-0.2,2.6-0.7c0.8-0.5,1.4-1.1,1.8-1.9c0.4-0.8,0.7-1.7,0.7-2.7 c0-1-0.2-1.9-0.7-2.7c-0.4-0.8-1-1.4-1.8-1.9c-0.8-0.5-1.6-0.7-2.6-0.7c-0.9,0-1.8,0.2-2.6,0.7c-0.8,0.5-1.4,1.1-1.8,1.9 c-0.4,0.8-0.6,1.7-0.6,2.7c0,1,0.2,1.9,0.6,2.7c0.4,0.8,1,1.4,1.8,1.9C6,122.8,6.8,123.1,7.8,123.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.1,125.6c-1.6,0-3-0.3-4.2-1c-1.2-0.7-2.2-1.6-2.9-2.8c-0.7-1.2-1-2.5-1-4.1c0-1.5,0.3-2.9,1-4.1 s1.5-2.1,2.7-2.8c1.1-0.7,2.5-1,4-1c1.5,0,2.7,0.3,3.8,1c1.1,0.6,1.9,1.5,2.4,2.7c0.6,1.1,0.8,2.5,0.8,3.9c0,0.4-0.1,0.7-0.4,0.9 c-0.2,0.2-0.6,0.4-0.9,0.4H21v-2.3h11.3l-1.2,0.8c0-0.9-0.2-1.8-0.6-2.5c-0.4-0.7-0.9-1.3-1.5-1.8c-0.7-0.4-1.5-0.6-2.4-0.6 c-1.1,0-2,0.2-2.8,0.7c-0.8,0.5-1.3,1.1-1.7,1.9c-0.4,0.8-0.6,1.7-0.6,2.8s0.2,2,0.7,2.8c0.5,0.8,1.1,1.5,1.9,1.9 c0.8,0.5,1.8,0.7,2.9,0.7c0.6,0,1.2-0.1,1.8-0.3c0.6-0.2,1.1-0.5,1.5-0.7c0.3-0.2,0.6-0.3,0.9-0.3s0.6,0.1,0.9,0.3 c0.3,0.3,0.5,0.6,0.5,0.9c0,0.3-0.1,0.6-0.5,0.9c-0.6,0.5-1.4,0.9-2.4,1.2C28.9,125.5,28,125.6,27.1,125.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.1,125.6c-1.6,0-3-0.3-4.2-1c-1.2-0.7-2.2-1.6-2.9-2.8c-0.7-1.2-1-2.5-1-4.1c0-1.5,0.3-2.9,1-4.1 s1.5-2.1,2.7-2.8c1.1-0.7,2.5-1,4-1c1.5,0,2.7,0.3,3.8,1c1.1,0.6,1.9,1.5,2.4,2.7c0.6,1.1,0.8,2.5,0.8,3.9c0,0.4-0.1,0.7-0.4,0.9 c-0.2,0.2-0.6,0.4-0.9,0.4H38v-2.3h11.3l-1.2,0.8c0-0.9-0.2-1.8-0.6-2.5c-0.4-0.7-0.9-1.3-1.5-1.8c-0.7-0.4-1.5-0.6-2.4-0.6 c-1.1,0-2,0.2-2.8,0.7c-0.8,0.5-1.3,1.1-1.7,1.9c-0.4,0.8-0.6,1.7-0.6,2.8s0.2,2,0.7,2.8c0.5,0.8,1.1,1.5,1.9,1.9 c0.8,0.5,1.8,0.7,2.9,0.7c0.6,0,1.2-0.1,1.8-0.3c0.6-0.2,1.1-0.5,1.5-0.7c0.3-0.2,0.6-0.3,0.9-0.3s0.6,0.1,0.9,0.3 c0.3,0.3,0.5,0.6,0.5,0.9c0,0.3-0.1,0.6-0.5,0.9c-0.6,0.5-1.4,0.9-2.4,1.2C45.8,125.5,44.9,125.6,44.1,125.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.8,119.9c-0.4,0-0.8-0.1-1-0.4c-0.3-0.3-0.4-0.6-0.4-1v-13.6c0-0.4,0.1-0.8,0.4-1c0.3-0.3,0.6-0.4,1-0.4 c0.4,0,0.8,0.1,1,0.4c0.3,0.3,0.4,0.6,0.4,1v13.6c0,0.4-0.1,0.8-0.4,1C56.6,119.8,56.2,119.9,55.8,119.9z M55.8,125.5 c-0.4,0-0.8-0.1-1-0.4c-0.3-0.3-0.4-0.6-0.4-1v-12.6c0-0.4,0.1-0.8,0.4-1c0.3-0.3,0.6-0.4,1-0.4c0.4,0,0.8,0.1,1,0.4 c0.3,0.3,0.4,0.6,0.4,1v12.6c0,0.4-0.1,0.8-0.4,1C56.6,125.4,56.2,125.5,55.8,125.5z M67.4,125.5c-0.4,0-0.8-0.1-1-0.4 c-0.3-0.3-0.4-0.6-0.4-1v-6.9c0-1.1-0.2-1.9-0.6-2.6s-0.9-1.2-1.6-1.5c-0.7-0.3-1.4-0.5-2.3-0.5c-0.8,0-1.5,0.2-2.1,0.5 c-0.6,0.3-1.1,0.7-1.5,1.3c-0.4,0.5-0.6,1.2-0.6,1.8h-1.8c0-1.2,0.3-2.2,0.9-3.2c0.6-0.9,1.4-1.7,2.4-2.2c1-0.5,2.1-0.8,3.4-0.8 c1.3,0,2.5,0.3,3.5,0.8c1,0.6,1.8,1.4,2.4,2.4s0.9,2.4,0.9,4v6.9c0,0.4-0.1,0.8-0.4,1C68.2,125.4,67.8,125.5,67.4,125.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.4,107.5c-0.5,0-0.9-0.2-1.3-0.5c-0.4-0.4-0.5-0.8-0.5-1.3c0-0.5,0.2-0.9,0.5-1.3c0.4-0.4,0.8-0.6,1.3-0.6 c0.5,0,0.9,0.2,1.3,0.6s0.6,0.8,0.6,1.3c0,0.5-0.2,0.9-0.6,1.3C76.3,107.4,75.9,107.5,75.4,107.5z M75.4,125.5 c-0.4,0-0.8-0.1-1-0.4c-0.3-0.3-0.4-0.6-0.4-1v-12.6c0-0.4,0.1-0.8,0.4-1c0.3-0.3,0.6-0.4,1-0.4c0.4,0,0.8,0.1,1,0.4 c0.3,0.3,0.4,0.6,0.4,1v12.6c0,0.4-0.1,0.8-0.4,1C76.1,125.4,75.8,125.5,75.4,125.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.4,125.5c-0.6,0-1-0.3-1.4-0.9l-6-12.6c-0.2-0.3-0.2-0.6,0-0.9s0.4-0.6,0.7-0.7c0.3-0.2,0.6-0.2,1-0.1 c0.3,0.1,0.6,0.3,0.7,0.6l5.6,12.1h-1.4l5.5-12.1c0.2-0.3,0.4-0.5,0.8-0.6c0.3-0.1,0.7-0.1,1.1,0.1c0.3,0.2,0.6,0.4,0.7,0.7 c0.1,0.3,0.1,0.6-0.1,1l-6,12.6C88.4,125.2,88,125.5,87.4,125.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.3,125.6c-1.6,0-3-0.3-4.2-1c-1.2-0.7-2.2-1.6-2.9-2.8c-0.7-1.2-1-2.5-1-4.1c0-1.5,0.3-2.9,1-4.1 s1.5-2.1,2.7-2.8c1.1-0.7,2.5-1,4-1c1.5,0,2.7,0.3,3.8,1c1.1,0.6,1.9,1.5,2.4,2.7c0.6,1.1,0.8,2.5,0.8,3.9c0,0.4-0.1,0.7-0.4,0.9 c-0.2,0.2-0.6,0.4-0.9,0.4H98.3v-2.3h11.3l-1.2,0.8c0-0.9-0.2-1.8-0.6-2.5c-0.4-0.7-0.9-1.3-1.5-1.8c-0.7-0.4-1.5-0.6-2.4-0.6 c-1.1,0-2,0.2-2.8,0.7c-0.8,0.5-1.3,1.1-1.7,1.9c-0.4,0.8-0.6,1.7-0.6,2.8s0.2,2,0.7,2.8c0.5,0.8,1.1,1.5,1.9,1.9 c0.8,0.5,1.8,0.7,2.9,0.7c0.6,0,1.2-0.1,1.8-0.3c0.6-0.2,1.1-0.5,1.5-0.7c0.3-0.2,0.6-0.3,0.9-0.3s0.6,0.1,0.9,0.3 c0.3,0.3,0.5,0.6,0.5,0.9c0,0.3-0.1,0.6-0.5,0.9c-0.6,0.5-1.4,0.9-2.4,1.2C106.1,125.5,105.2,125.6,104.3,125.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,148.3l0.4-0.8c0.4,0.4,0.9,0.6,1.3,0.8c0.5,0.2,1,0.2,1.6,0.2c0.7,0,1.3-0.1,1.6-0.4s0.6-0.7,0.6-1.2 c0-0.3-0.1-0.5-0.3-0.7s-0.4-0.3-0.7-0.4c-0.3-0.1-0.7-0.2-1.2-0.3c-0.7-0.2-1.2-0.3-1.7-0.5c-0.4-0.2-0.8-0.4-1.1-0.7 c-0.3-0.3-0.4-0.7-0.4-1.3c0-0.5,0.1-0.9,0.4-1.3c0.3-0.4,0.6-0.7,1.1-0.9c0.5-0.2,1-0.3,1.7-0.3c0.6,0,1.2,0.1,1.7,0.3 c0.5,0.2,1,0.5,1.3,0.8l-0.4,0.8c-0.4-0.4-0.8-0.6-1.3-0.8s-0.9-0.2-1.4-0.2c-0.7,0-1.2,0.1-1.6,0.4c-0.4,0.3-0.6,0.7-0.6,1.2 c0,0.4,0.2,0.8,0.5,1c0.3,0.2,0.9,0.4,1.5,0.6c0.8,0.2,1.3,0.4,1.8,0.5s0.8,0.4,1.1,0.7c0.3,0.3,0.4,0.7,0.4,1.2 c0,0.5-0.1,0.9-0.4,1.3s-0.6,0.7-1.1,0.9c-0.5,0.2-1.1,0.3-1.7,0.3C15.2,149.4,14.1,149,13.3,148.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.3,149c-0.4-0.3-0.8-0.6-1-1.1c-0.2-0.5-0.4-1-0.4-1.7c0-0.6,0.1-1.2,0.4-1.7c0.2-0.5,0.6-0.8,1-1.1 c0.4-0.3,0.9-0.4,1.5-0.4s1.1,0.1,1.5,0.4c0.4,0.3,0.8,0.6,1,1.1c0.2,0.5,0.4,1,0.4,1.7c0,0.6-0.1,1.2-0.4,1.7 c-0.2,0.5-0.6,0.8-1,1.1c-0.4,0.3-0.9,0.4-1.5,0.4S22.7,149.2,22.3,149z M25.2,147.9c0.3-0.4,0.5-1,0.5-1.7c0-0.7-0.2-1.3-0.5-1.7 c-0.3-0.4-0.8-0.6-1.4-0.6s-1,0.2-1.4,0.6c-0.3,0.4-0.5,1-0.5,1.7c0,0.7,0.2,1.3,0.5,1.7c0.3,0.4,0.8,0.6,1.4,0.6 C24.4,148.5,24.9,148.3,25.2,147.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.2,149c-0.4-0.3-0.8-0.6-1-1.1c-0.2-0.5-0.4-1-0.4-1.7s0.1-1.2,0.4-1.7s0.6-0.8,1-1.1s1-0.4,1.6-0.4 c0.4,0,0.8,0.1,1.2,0.2s0.7,0.3,0.9,0.6l-0.3,0.7c-0.6-0.5-1.2-0.7-1.7-0.7c-0.6,0-1.1,0.2-1.5,0.6c-0.3,0.4-0.5,1-0.5,1.7 c0,0.7,0.2,1.3,0.5,1.7c0.3,0.4,0.8,0.6,1.5,0.6c0.6,0,1.2-0.2,1.7-0.7l0.3,0.7c-0.3,0.2-0.6,0.4-1,0.6c-0.4,0.1-0.8,0.2-1.2,0.2 C30.2,149.4,29.7,149.2,29.2,149z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.1,140.6h1.2v1.1h-1.2V140.6z M34.2,149.3v-6.1h1v6.1H34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.3,143.7c0.4,0.4,0.6,1,0.6,1.8v3.8h-1v-1c-0.2,0.4-0.4,0.6-0.7,0.8c-0.3,0.2-0.7,0.3-1.1,0.3 c-0.4,0-0.7-0.1-1.1-0.2c-0.3-0.2-0.6-0.4-0.8-0.7c-0.2-0.3-0.3-0.6-0.3-0.9c0-0.5,0.1-0.8,0.3-1.1c0.2-0.3,0.6-0.4,1.1-0.5 c0.5-0.1,1.3-0.2,2.2-0.2h0.3v-0.4c0-0.5-0.1-0.9-0.3-1.1c-0.2-0.2-0.5-0.3-1-0.3c-0.7,0-1.4,0.2-2.1,0.6l-0.3-0.7 c0.3-0.2,0.7-0.4,1.1-0.5c0.4-0.1,0.9-0.2,1.3-0.2C40.3,143.1,40.9,143.3,41.3,143.7z M40.4,148.1c0.3-0.3,0.5-0.8,0.5-1.3v-0.4 h-0.2c-0.7,0-1.3,0-1.7,0.1c-0.4,0.1-0.7,0.2-0.8,0.3c-0.2,0.1-0.2,0.4-0.2,0.6c0,0.3,0.1,0.6,0.4,0.8c0.2,0.2,0.5,0.3,0.9,0.3 C39.6,148.6,40,148.4,40.4,148.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.7,149.3v-8.8h1v8.8H43.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56,140.5h1v8.8h-0.8l-5.3-7.1v7.1h-1v-8.8h0.8l5.3,7.1V140.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.1,146.4h-4.4c0,0.7,0.2,1.2,0.6,1.6s0.8,0.5,1.5,0.5c0.7,0,1.4-0.2,1.9-0.7l0.3,0.7 c-0.3,0.2-0.6,0.4-1,0.6s-0.8,0.2-1.3,0.2c-0.9,0-1.7-0.3-2.2-0.8c-0.5-0.6-0.8-1.3-0.8-2.3c0-0.6,0.1-1.2,0.4-1.7 c0.2-0.5,0.6-0.8,1-1.1c0.4-0.3,0.9-0.4,1.5-0.4c0.8,0,1.4,0.3,1.9,0.8c0.5,0.5,0.7,1.3,0.7,2.2V146.4z M60.2,144.4 c-0.3,0.3-0.5,0.8-0.6,1.4h3.5c0-0.6-0.2-1.1-0.5-1.4c-0.3-0.3-0.7-0.5-1.2-0.5C61,143.9,60.5,144,60.2,144.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.7,148.5l0,0.8c-0.2,0-0.4,0-0.6,0c-0.7,0-1.3-0.2-1.7-0.6c-0.4-0.4-0.6-0.9-0.6-1.6V144h-1.2v-0.8h1.2 v-1.8h1v1.8h1.7v0.8h-1.7v3.1c0,1,0.4,1.4,1.3,1.4C68.4,148.6,68.5,148.6,68.7,148.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M78.1,143.2h1l-2.3,6.1h-1l-1.7-4.7l-1.7,4.7h-1l-2.3-6.1h1l1.7,4.9l1.8-4.9h0.9l1.7,4.9L78.1,143.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.2,149c-0.4-0.3-0.8-0.6-1-1.1c-0.2-0.5-0.4-1-0.4-1.7c0-0.6,0.1-1.2,0.4-1.7c0.2-0.5,0.6-0.8,1-1.1 c0.4-0.3,0.9-0.4,1.5-0.4s1.1,0.1,1.5,0.4c0.4,0.3,0.8,0.6,1,1.1c0.2,0.5,0.4,1,0.4,1.7c0,0.6-0.1,1.2-0.4,1.7 c-0.2,0.5-0.6,0.8-1,1.1c-0.4,0.3-0.9,0.4-1.5,0.4S81.7,149.2,81.2,149z M84.1,147.9c0.3-0.4,0.5-1,0.5-1.7c0-0.7-0.2-1.3-0.5-1.7 c-0.3-0.4-0.8-0.6-1.4-0.6s-1,0.2-1.4,0.6c-0.3,0.4-0.5,1-0.5,1.7c0,0.7,0.2,1.3,0.5,1.7c0.3,0.4,0.8,0.6,1.4,0.6 C83.4,148.5,83.8,148.3,84.1,147.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.6,143.9l-0.7,0.1c-0.6,0.1-1.1,0.3-1.4,0.6s-0.4,0.7-0.4,1.2v3.5h-1v-6.1h1v1.1c0.3-0.7,1-1.1,2-1.2 l0.4,0L90.6,143.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97,149.3h-1.3l-3.1-2.9v2.9h-1v-8.8h1v5.5l2.8-2.7h1.3l-3,2.9L97,149.3z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.3483,
    y1: 39.3927,
    x2: 54.3483,
    y2: 57.4994
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05319245,
    style: {
      stopColor: "#A887F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8224E3"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.3,21.4c-10.9,0-19.7,8.8-19.7,19.7c0,10.9,8.8,19.7,19.7,19.7c10.9,0,19.7-8.8,19.7-19.7 C74,30.2,65.2,21.4,54.3,21.4z M54.3,53.1c-6.6,0-12-5.4-12-12s5.4-12,12-12c6.6,0,12,5.4,12,12S61,53.1,54.3,53.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.3683,
    y1: 41.0802,
    x2: 66.3284,
    y2: 41.0802
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04078348,
    style: {
      stopColor: "#A887F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9883,
    style: {
      stopColor: "#8224E3"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.3,29.1c-6.6,0-12,5.4-12,12s5.4,12,12,12c6.6,0,12-5.4,12-12S61,29.1,54.3,29.1z M54.3,49.2 c-4.5,0-8.1-3.6-8.1-8.1c0-4.5,3.6-8.1,8.1-8.1c4.5,0,8.1,3.6,8.1,8.1C62.4,45.5,58.8,49.2,54.3,49.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.7386,
    y1: 8.9254,
    x2: 82.507,
    y2: 8.9254
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.434346e-7,
    style: {
      stopColor: "#39B54A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D9E021"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 78.6,
    cy: 8.9,
    r: 3.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.1609,
    y1: 71.2717,
    x2: 84.2043,
    y2: 12.2283
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000002163083,
    style: {
      stopColor: "#8224E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A887F9",
      stopOpacity: 0
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 54.7,
    cy: 41.8,
    r: 41
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVertical);
export default __webpack_public_path__ + "static/media/logo-vertical.3d5f57fdbd3afe691f68cbee340df8df.svg";
export { ForwardRef as ReactComponent };